import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

// 行星符号映射（用于美化展示）
const PLANET_SYMBOLS = {
  太阳: '☉',
  月亮: '☽',
  水星: '☿',
  金星: '♀',
  火星: '♂',
  木星: '♃',
  土星: '♄',
};

// 牌组英文标识（用于 CSS class）
const SUIT_KEYS = {
  权杖: 'wand',
  圣杯: 'cup',
  宝剑: 'sword',
  星币: 'coin',
};

// 牌组顺序（ princess -> prince -> queen -> king ）
const RANK_ORDER = ['公主', '王子', '王后', '国王'];

export default class SevenstarResult extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  view() {
    const { results, queryInfo, aceResults } = this.attrs;

    if (!results) return null;

    // 牌组顺序：权杖 -> 圣杯 -> 宝剑 -> 星币
    const suitOrder = ['权杖', '圣杯', '宝剑', '星币'];

    return (
      <div className="TaroSevenstarResult">
        {/* 查询参数回显 */}
        {queryInfo && (
          <div className="TaroSevenstarResult-queryInfo">
            <div className="TaroSevenstarResult-queryInfo-item">
              <i className="fas fa-clock" />
              <strong>时间：</strong>
              {queryInfo.draw_datetime} ({queryInfo.timezone})
            </div>
            <div className="TaroSevenstarResult-queryInfo-item">
              <i className="fas fa-map-marker-alt" />
              <strong>城市：</strong>
              {queryInfo.city.name}（{queryInfo.city.lat}, {queryInfo.city.lon}）
            </div>
          </div>
        )}

        {/* ACE 组（单独一组，不混入宫廷牌） */}
        {aceResults && aceResults.length > 0 && (
          <div className="TaroSevenstarResult-aceSection">
            <div className="TaroSevenstarResult-aceHeader">
              <span className="TaroSevenstarResult-aceHeader-icon">🃏</span>
              <span className="TaroSevenstarResult-aceHeader-title">首牌组（ACE）</span>
              <span className="TaroSevenstarResult-aceHeader-hint">七星 = 同花色公主牌</span>
            </div>
            <div className="TaroSevenstarResult-aceCards">
              {aceResults.map((card) => {
                const symbol = PLANET_SYMBOLS[card.planet] || '';
                return (
                  <div className="TaroSevenstarResult-aceCard" key={card.card_name}>
                    <div className="TaroSevenstarResult-aceCard-name">{card.card_name}</div>
                    <div className="TaroSevenstarResult-aceCard-planet">
                      <span className="TaroSevenstarResult-card-planet-symbol">{symbol}</span>
                      <span className="TaroSevenstarResult-card-planet-name">{card.planet}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* 4 牌组分组展示 */}
        <div className="TaroSevenstarResult-groups">
          {suitOrder.map((suit) => {
            const group = results[suit];
            if (!group) return null;

            // 按 rank 排序：公主 -> 王子 -> 王后 -> 国王
            const sortedCards = [...group.cards].sort((a, b) => {
              const ra = RANK_ORDER.findIndex((r) => a.card_name.endsWith(r));
              const rb = RANK_ORDER.findIndex((r) => b.card_name.endsWith(r));
              return ra - rb;
            });

            return (
              <div className={`TaroSevenstarResult-group TaroSevenstarResult-group-${SUIT_KEYS[suit]}`}>
                <div className="TaroSevenstarResult-group-header">
                  <span className="TaroSevenstarResult-group-icon">{group.icon}</span>
                  <span className="TaroSevenstarResult-group-title">{suit}组</span>
                  <span className="TaroSevenstarResult-group-element">
                    （{group.element}元素）
                  </span>
                </div>
                <div className="TaroSevenstarResult-group-cards">
                  {sortedCards.map((card) => {
                    const symbol = PLANET_SYMBOLS[card.planet] || '';
                    return (
                      <div className="TaroSevenstarResult-card" key={card.card_name}>
                        <div className="TaroSevenstarResult-card-name">
                          {card.card_name}
                        </div>
                        <div className="TaroSevenstarResult-card-planet">
                          <span className="TaroSevenstarResult-card-planet-symbol">
                            {symbol}
                          </span>
                          <span className="TaroSevenstarResult-card-planet-name">
                            {card.planet}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
